export default __webpack_public_path__ + "static/media/exten1.c5f6126b.jpeg";